import styled from 'styled-components';
import { Form as FormContainer } from 'formik';
import fourPeopleImage from './four-people.png';
import { cssVariables } from '../../cssVariables';
import { colors } from '../../colors';

export const UserContainer = styled.div`
  display:flex;
  flex-wrap:wrap;
  flex-direction:row;
  justify-content:flex-start;
  align-items:stretch;
`;

export const Form = styled(FormContainer)`
    width:75%;
`;

export const Title = styled.div`
    font-size: 2rem;
    font-weight: 400;
    width:100%;
`;

export const SubTitle = styled.div`
    font-size: 1rem;
    width: 70%;
    margin:0 auto;
`;
export const SubHeading = styled.div`
    font-size: 1rem;
		width: 70%;
		margin:0 auto;
    padding:0.7em;
`;
export const UserForm = styled.div`
    flex:50%;
    text-align: center;
    display:flex;
    align-items: center;
    justify-content: flex-start;
    padding:2em;

    @media screen and (max-width: ${cssVariables.mobileBreakpoint}) {
      padding-top: 3rem;
      flex-basis:100%;
      flex-direction: column-reverse;
    }
`;

export const BackgroundImage = styled.div`
    background: url(${fourPeopleImage}) bottom left no-repeat;
    min-height: 90vh;
    flex: 50%;
    margin-bottom:0.75em;

    @media screen and (max-width: ${cssVariables.mobileBreakpoint}) {
      flex-basis:100%;
      order:2;
    }
`;

export const FormFields = styled.div`
    padding: 1rem;

    .FormField {
      margin-bottom: 1em;
    }

    @media screen and (max-width: ${cssVariables.tabletBreakpoint}) {
      width: 100%;
    }

    @media screen and (max-width: ${cssVariables.mobileBreakpoint}) {
      width: 95%;
      margin: 0 auto;
    }
`;

export const FormFooterNote = styled.div`
  margin-top:1em;
`;

export const FormFooterLink = styled.div`
  margin-top:1em;
  color: ${colors.circleBlue};
`;
export const CreatePopUpSubHeading = styled.div`
    font-size: 1rem;
		width: 70%;
		margin:0 auto;
		padding:0.7em;
		padding-bottom:0em;
`;